module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Readers love SJD Peterson’s")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Pony")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("“Love this book, love the series, love the author… that’s just a whole heap of love pouring out of me for this latest instalment in the Guards of Folsom series.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("—Sinfully Sexy Books")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("“I enjoyed this addition to the series and thought it went in ways that I didn’t quite expect. I can’t wait to see which kink is up next!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("—Guilty Indulgence Romance Review")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("“I am a huge fan of the Guards of Folsom series by SJD Peterson, and I think this is my favorite book so far. It is a story that manages to be warm and romantic, while at the same time being totally hot and sexy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("—Joyfully Jay")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("“One of the things I love about this author’s writing is just how vividly the characters come to life. They seem like real people that you truly grow to care for. I love this series and love this author’s work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("—Hearts on Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("“I was captivated by this third installment in the series and am now lusting after more. Thank you, again, to the incredible author, Jo Peterson, for giving voices to my guys and another beautiful love story for me to enjoy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("—Rainbow Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("“For me this was perhaps the best in the series. It had it all, the kinks, the awesome couple, the hot mind-blowing scenes, and joy. Yup, that’s mostly my favorite part, the fact that it made me have this stupid grin on my face during the entire read.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("—MM Good Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("“The third installment in the Guards of Folsom series, and it totally renewed my love for the series…. I’d say this was the best Folsom book to date!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("—3 Chicks After Dark")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac69130","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002.vue
// module id = 57
// module chunks = 0